import React, { ReactNode, memo } from 'react';
import { defaultTheme } from '@styles/theme.styled';
import { StyledSection, Content } from './section.styled';

interface SectionProperties {
  children: ReactNode;
  backgroundColor: keyof typeof defaultTheme.backgroundColors;
  className?: string;
  anchorId?: string;
}

const Section = memo(
  ({
    anchorId,
    className = '',
    children,
    backgroundColor = 'white',
  }: SectionProperties): JSX.Element => {
    const classes = `section-${backgroundColor}${className ? ` ${className}` : ''}`;

    return (
      <StyledSection backgroundColor={backgroundColor} className={classes} id={anchorId}>
        <Content>{children}</Content>
      </StyledSection>
    );
  }
);

Section.displayName = 'Section';

export default Section;
